export default __webpack_public_path__ + "static/media/Group 6461@3x.eb8703c4.png";